import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { Card } from '../components'
import authContext from '../context/auth-context'
import { ToastContainer, toast } from 'react-toastify'
import { CartContext } from '../context/CartContext'


const WebShopContainer = styled.div`
  display:flex;
  justify-content:center;
  @media screen and (max-width:768px){
      margin-top: 50px;
  }

`
const WebShop = () => {
  const {products, getProducts} = useContext(authContext)
  const {added, setCart} = useContext(CartContext)
  useEffect(()=>{
    getProducts()
    if(added){
      toast(`product added to the cart`, {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
    }
    // eslint-disable-next-line

    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    setCart(cartItems)
    // eslint-disable-next-line
  },[added])
  return (
    <>
    <WebShopContainer className='animated slideInDown'>
        {products?.map(item => (
            <Card
              key={item._id}
              images={item.images}
              category={item.categoryName}
              title={item.title}
              description={item.description}
              stars='5/5'
              price={item.price}
              productId={item._id}
            />
        ))}
    </WebShopContainer>
    {/* <StripeCheckoutHandler /> */}
    <ToastContainer
      position="bottom-center"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      style={{textAlign:'center'}}
      />
    </>
    
  )
}

export default WebShop